import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { dateTolocale } from 'utils/converter';
import { DateFormat } from 'custom/constants';

const primaryBlue = '#092b4a';
const borderColor = primaryBlue;
const textColor = primaryBlue;

const styles = StyleSheet.create({
  headerContainer: { marginTop: 24, },
  title: {
    fontSize: 9,
    textTransform: 'uppercase',
    backgroundColor: '#f0f0f0',
    color: primaryBlue,
    padding: '4px 35px',
    textAlign: 'center',
    marginBottom: 5,
    lineHeight: 'normal',
    fontFamily: 'NunitoMedium',
    borderBottom: `2px solid ${primaryBlue}`,
  },
  noteWrapper: { 
    padding: 4,
    fontFamily: 'NunitoRegular',
  },
  replyWrapper: { 
    borderBottom: '1px dashed lightgrey',
    padding: 2, 
    paddingBottom: 0,
    paddingLeft: 20,
  },
  borderBottom: { borderBottom: '1px dashed lightgrey', },
  data: {
    fontSize: 9,
    paddingBottom: 3,
    lineHeight: 'normal',
  },
  noteBy: { fontSize: 9 },
  note: {
    fontSize: 9,
    color: 'grey'
  },
  noDataRow: {
    fontSize: 9,
    width: '100%',
    textAlign: 'center',
    padding: 4,
    color: textColor,
    fontFamily: 'NunitoRegular',
    borderColor: borderColor,
    borderWidth: 1,
  },
  stackHorizontal: {
    display: 'flex',
    flexDirection: 'row',
  }
});


const FlightNotes = (props) => {
  const { notes } = props;
  return (
    <View style={styles.headerContainer}>
      <Text style={styles.title}>Notes</Text>
      {notes && notes.length > 0 ? notes.map((list) => {
        return (
          <View key={list?.id} style={styles.noteWrapper}>
            <View style={[styles.stackHorizontal, list?.replys.length > 0 ? '' : styles.borderBottom]}>
              <Text style={styles.data}>{list?.user?.first_name} {list?.user?.last_name} | {dateTolocale(list.created, `${DateFormat} HHmm`)?.toUpperCase()} -- </Text>
              <Text style={styles.note}>{list?.note}</Text>
            </View>

            {list?.replys && list?.replys.map((item, index) => (
              <View key={index} style={[styles.stackHorizontal, styles.replyWrapper]}>
                <Text style={styles.noteBy}>{item.user?.first_name} {item.user?.last_name} | {dateTolocale(item.created, `${DateFormat} HHmm`)?.toUpperCase()} -- </Text>
                <Text style={styles.note}>{item.note}</Text>
              </View>
            ))}
          </View>
        );
      }) : <View  style={styles.noDataRow}>
        <Text>No Data</Text>
      </View>
      }
    </View>
  );
};
  
export default FlightNotes;